import axios from 'axios'
import type { FilterPreset, FilterSchema, SearchFilterAdapter } from '@/components/searchFilter/types'
import { choiceContinuation, flattenChoices } from '@/components/searchFilter/choices'
import { emptyState } from '@/components/searchFilter/model'
import { getApiError } from '@/composables/getApiError'
import { BASE_URL } from '@/environment/environment'

const base = `${BASE_URL}/api/adverse/adverse-event/`
const savedUrl = `${BASE_URL}/api/employee/filter-presets/`
export const adverseSearchAdapter: SearchFilterAdapter = {
  async loadSchema() {
    const { data } = await axios.get<FilterSchema>(`${base}search-schema/`)
    return { ...data, fields: data.fields.map(field => ({ ...field, tree: ['event_types', 'departments'].includes(field.key) })) }
  },
  async loadChoices(field, search, cursor, ids) {
    const params: Record<string, string | number> = { field, search_field: search, page_size: 50 }
    if (cursor) {
      const continuation = new URLSearchParams(cursor)
      for (const key of ['cursor', 'page']) {
        if (continuation.has(key)) params[key] = continuation.get(key)!
      }
    }
    if (ids) params.ids = ids.join(',')
    const { data } = await axios.get(`${base}${ids ? 'search-choices' : 'filter-choices'}/`, { params })
    return { options: flattenChoices(data.results), cursor: choiceContinuation(data.next) }
  },
  async loadPresets() {
    return (await axios.get(savedUrl, { params: { module: 'adverse' } })).data
  },
  async savePreset(name, value, id) {
    try {
      return (id ? await axios.patch(`${savedUrl}${id}/`, { name, state: value }) : await axios.post(savedUrl, { module: 'adverse', name, state: value })).data
    } catch (error) {
      throw new Error(getApiError(error, 'Не удалось сохранить фильтр. Повторите попытку.'))
    }
  },
  async deletePreset(id) {
    await axios.delete(`${savedUrl}${id}/`)
  },
}
export const adverseSearchDefaults: FilterPreset[] = [
  { id: -1, name: 'Все доступные НС', state: emptyState() },
  { id: -2, name: 'Требует действия', state: { search: '', filter: { match: 'all', conditions: [{ field: 'requires_action', operator: 'in', value: ['true'] }] } } },
  { id: -3, name: 'Мои активные НС', state: { search: '', filter: { match: 'all', conditions: [{ field: 'is_active', operator: 'in', value: ['true'] }] } } },
]
